/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexampleblackwhite3Inputs */

const en_refineexampleblackwhite3 = /** @type {(inputs: Refineexampleblackwhite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Black & white`)
};

const de_refineexampleblackwhite3 = /** @type {(inputs: Refineexampleblackwhite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwarz-Weiß`)
};

/**
* | output |
* | --- |
* | "Black & white" |
*
* @param {Refineexampleblackwhite3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexampleblackwhite3 = /** @type {((inputs?: Refineexampleblackwhite3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexampleblackwhite3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexampleblackwhite3(inputs)
	return de_refineexampleblackwhite3(inputs)
});
export { refineexampleblackwhite3 as "refineExampleBlackWhite" }